var SelectModule = require('../modules/select')

var Module = {
    name: 'countries',
    selectors: {
        select2: '#countriesList',
        select2Fake: '#countriesListFake'
    },

    init: function () {
        Module.select2Init();
    },

    select2Init: function () {
        var select = $(document).find(Module.selectors.select2);
        SelectModule.init($(document).find(Module.selectors.select2Fake), allCountries)

        if (select.length) {
            const selectParent = $(Module.selectors.select2).parent('.form-group');

            SelectModule.init(select, allCountries).on('select2:select', function (e) {
                selectParent.removeClass('has-error')
                let option = $(e.params.data.element);

                if (option.val() !== '') {
                    selectParent.children('label').addClass('active')
                } else {
                    selectParent.children('label').removeClass('active')
                }

                $.event.trigger({type: Module.name + ':changed', countryData: e.params.data});
            });

            let preSelectCountry = allCountries.find(function(country) {
                return country.id == select.val();
            });
            $.event.trigger({
                type: Module.name + ':init',
                countryData: {
                    id: (preSelectCountry)? preSelectCountry.id : null,
                    code: (preSelectCountry)? preSelectCountry.code : null,
                    states_count: (preSelectCountry)? preSelectCountry.states_count : null,
                }
            })
        }
    }
}

module.exports = Module
